(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ease-mix-match"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[id^="ease-mm-"]').forEach(function(root){
  var scrollBtn = root.querySelector('[data-ease-mm-scroll]');
  if (scrollBtn) {
    scrollBtn.addEventListener('click', function(){
      var target = document.querySelector('form[action*="/cart/add"]');
      if (target) { target.scrollIntoView({behavior:'smooth', block:'center'}); }
      else if (scrollBtn.dataset.fallbackUrl) { window.location.href = scrollBtn.dataset.fallbackUrl; }
    });
  }
  var dialog = root.querySelector('[data-ease-mm-dialog]');
  var openBtn = root.querySelector('[data-ease-mm-size-open]');
  var closeBtn = root.querySelector('[data-ease-mm-size-close]');
  if (dialog && openBtn) {
    openBtn.addEventListener('click', function(){ dialog.showModal(); });
    if (closeBtn) closeBtn.addEventListener('click', function(){ dialog.close(); });
    dialog.addEventListener('click', function(e){ if (e.target === dialog) dialog.close(); });
  }
});

  } catch(e) { console.error(e); }
})();
})();
